import { createContext, useContext, useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import db from "../firebase/firebaseConfig"; 

const LocalContext = createContext();

export const LocalProvider = ({ children }) => {
  const [showCallModal, setShowCallModal] = useState(false);
  const [currentTFN, setCurrentTFN] = useState({
    intlFormat: "",
    localFormat: "",
    popup: false,
  });
  const [popupEnabled, setPopupEnabled] = useState(false);
  const [webinfo, setwebinfo] = useState({
    name: "webantidigi.com",
    phone: "",
    phonecall: "",
    email: "contact@webantidigi.com",
    address: "India",
    logo: "https://res.cloudinary.com/dmtqckyli/image/upload/v1772897729/a3266574-f368-4112-9b7d-99c709b0749c.png",
    logowhite: "https://res.cloudinary.com/dmtqckyli/image/upload/v1772897729/a3266574-f368-4112-9b7d-99c709b0749c.png",
  });

  useEffect(() => {
    const fetchTFN = async () => {
      try {
        const docRef = doc(db, "siteNumbers", "webantidigi.com");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          const popupValue = Boolean(data.popup);
          setCurrentTFN({
            intlFormat: data.numberIntl || "",
            localFormat: data.numberLocal || "",
            popup: popupValue,
          });
          setPopupEnabled(popupValue);
        } else {
          setCurrentTFN({ intlFormat: "", localFormat: "", popup: false });
          setPopupEnabled(false);
        }
      } catch (error) {
        console.error("Error fetching TFN: ", error);
        setCurrentTFN({ intlFormat: "", localFormat: "", popup: false });
        setPopupEnabled(false);
      }
    };

    fetchTFN();
  }, []);

  useEffect(() => {
    setwebinfo((prevWebinfo) => ({
      ...prevWebinfo,
      phone: currentTFN.localFormat,
      phonecall: currentTFN.intlFormat,
      popup: currentTFN.popup,
    }));
  }, [currentTFN]);

  return (
    <LocalContext.Provider
      value={{
        webinfo,
        setwebinfo,
        showCallModal,
        setShowCallModal,
        popupEnabled,
        setPopupEnabled,
      }}
    >
      {children}
    </LocalContext.Provider>
  );
};

export const useLocalContext = () => useContext(LocalContext);
